import swal from "sweetalert";
import axiosInstance from "../api";
import { setTypeList, setSingleType } from "../../reusableSlice";

export const getAllTypes = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/types`, { params: data });
    if (response?.data) {
      dispatch(setTypeList(response?.data?.response || response?.data || []));
    } else {
      dispatch(setTypeList([]));
    }
  } catch (err) {
    dispatch(setTypeList([]));
  }
};

export const addType = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/types", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Type created successfully",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/type");
    } else {
      swal({
        text: response?.data?.message || "Failed to create type",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    swal({
      text: err?.response?.data?.message || "Something went wrong",
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } finally {
    setLoading(false);
  }
};

export const getSingleType = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/types/${id}`);
    if (response?.data) {
      dispatch(setSingleType(response?.data?.response || response?.data || {}));
    } else {
      dispatch(setSingleType({}));
    }
  } catch (err) {
    dispatch(setSingleType({}));
  }
};

export const updateOneType = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("admin/types", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Type updated successfully",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/type");
    } else {
      swal({
        text: response?.data?.message || "Failed to update type",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    swal({
      text: err?.response?.data?.message || "Something went wrong",
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } finally {
    setLoading(false);
  }
};

export const deleteOneType = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.delete(`admin/types/${id}`);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Type deleted successfully",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      window.location.reload();
    } else {
      swal({
        text: response?.data?.message || "Failed to delete type",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    swal({
      text: err?.response?.data?.message || "Something went wrong",
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  }
};
